import React, { useState } from 'react';
import "./Template.css";

function TemplatePage() {
  const [message, setMessage] = useState('');
  const [messages, setMessages] = useState([]);
  const [code, setCode] = useState('');
  const [isCodeModalOpen, setIsCodeModalOpen] = useState(false);
  const [hasCode, setHasCode] = useState(false);

  const handleAddCode = () => {
    setIsCodeModalOpen(true);
  };

  const handleSaveCode = () => {
    if (code.trim()) {
      setHasCode(true);
      localStorage.setItem('razorTemplate', code);
      setIsCodeModalOpen(false);
    }
  };

  const handleDeleteCode = () => {
    setCode('');
    setHasCode(false);
    localStorage.removeItem('razorTemplate');
    setIsCodeModalOpen(false);
  };

  const handleCloseModal = () => {
    setIsCodeModalOpen(false);
  };

  const handleViewCode = () => {
    const savedCode = localStorage.getItem('razorTemplate');
    if (savedCode) {
      setCode(savedCode);
      setIsCodeModalOpen(true);
    }
  };

  const sendMessage = () => {
    if (message.trim()) {
      const newMessage = {
        text: message,
        code: hasCode ? code : null,
        timestamp: new Date()
      };
      setMessages([...messages, newMessage]);
      setMessage('');
    }
  };

  const handleKeyPress = (e) => {
    if (e.key === 'Enter' && !e.shiftKey) {
      e.preventDefault();
      sendMessage();
    }
  };

  return (
    <div className="template-page">
      <div className="template-container">
        <div className="template-header">
          <h2>Шаблонізатор</h2>
        </div>

        <div className="template-messages">
          {messages.length === 0 ? (
            <div className="empty-state">
              <div>Чат розпочатий.</div>
              <div>Опишіть, який Razor-шаблон чека ви хочете згенерувати</div>
            </div>
          ) : (
            messages.map((msg, index) => (
              <div key={index} className="message-row">
                <div className="message-content">
                  {msg.text}
                  {msg.code && (
                    <button className="code-preview-button" onClick={handleViewCode}>
                      Код шаблону
                    </button>
                  )}
                </div>
                <div className="user-icon">
                  <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
                    <circle cx="12" cy="8" r="4" fill="#666"/>
                    <path d="M4 20c0-4 3.5-7 8-7s8 3 8 7" fill="#666"/>
                  </svg>
                </div>
              </div>
            ))
          )}
        </div>

        <div className="template-input-container">
          {hasCode && (
            <button className="code-status-button" onClick={handleViewCode}>
              Код шаблону
            </button>
          )}

          <div className="input-row">
            <button className="add-code-button" onClick={handleAddCode}>
              +
            </button>
            <input
              type="text"
              className="message-input"
              placeholder="Опишіть шаблон..."
              value={message}
              onChange={(e) => setMessage(e.target.value)}
              onKeyPress={handleKeyPress}
            />
            <button className="send-button" onClick={sendMessage}>
              Відправити
            </button>
          </div>
        </div>
      </div>

      {isCodeModalOpen && (
        <div className="modal-overlay" onClick={handleCloseModal}>
          <div className="modal-content" onClick={(e) => e.stopPropagation()}>
            <button className="close-button" onClick={handleCloseModal}>×</button>
            <h3>Код шаблону</h3>
            <textarea
              className="code-textarea"
              value={code}
              onChange={(e) => setCode(e.target.value)}
              placeholder="Вставте ваш Razor-код тут..."
            />
            <div className="modal-buttons">
              <button className="modal-save-button" onClick={handleSaveCode}>
                Зберегти
              </button>
              <button className="modal-delete-button" onClick={handleDeleteCode}>
                Видалити
              </button>
              <button className="modal-cancel-button" onClick={handleCloseModal}>
                Відмінити
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default TemplatePage;